import { Stack } from 'braid-design-system';
import React, {
  type ChangeEvent,
  type FocusEvent,
  type MouseEvent,
} from 'react';

import { Item, type ItemType } from '../Item';

export interface ItemListProps {
  handleEditItem: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  handleOnBlur?: (event: FocusEvent<HTMLTextAreaElement>) => void;
  handleOnFocus?: (event: FocusEvent<HTMLTextAreaElement>) => void;
  handleRemoveItem?: (event: MouseEvent<HTMLButtonElement>) => void;
  handleOnPaste?: () => void;
  items: ItemType[];
}

export const ItemList = ({
  handleEditItem,
  handleOnBlur,
  handleOnFocus,
  handleRemoveItem,
  handleOnPaste,
  items,
}: ItemListProps) =>
  items.length > 0 ? (
    <Stack space="medium">
      {items.map((item) => (
        <Item
          handleEditItem={handleEditItem}
          handleOnBlur={handleOnBlur}
          handleOnFocus={handleOnFocus}
          handleOnPaste={handleOnPaste}
          handleRemoveItem={handleRemoveItem}
          item={item}
          key={item.id}
        />
      ))}
    </Stack>
  ) : null;
